import { HugeiconsIcon } from '@hugeicons/react';
import { Route01Icon } from '@hugeicons/core-free-icons';
import { Band } from '../../../components/editorial/Band';
import { BENCH_SERVICES, SCRAPE_BENCHMARK } from '../../../data/scrapeBenchmark';
import { fmtUtcDate } from '../../../lib/format';
import { m } from '../../../paraglide/messages';
import { BenchmarkCard } from './BenchmarkCard';
import { ScrapeRouterSteps } from './ScrapeRouterSteps';
import { ScrapeRouterVideo } from './ScrapeRouterVideo';

/** web.scrape only: the scrape router's premise, its three steps, the launch
 *  video and the benchmark it won, as one graphic. The numbers come from
 *  `data/scrapeBenchmark.ts` alone. */
export const ScrapeRouterBand = () => (
  <Band>
    <div className="band">
      <div className="mx-auto max-w-245">
        <div className="flex flex-col items-center text-center">
          <h2 className="display-3 flex items-center gap-2.5 text-text">
            <span className="grid size-9 shrink-0 place-items-center rounded-10 bg-accent-soft text-accent">
              <HugeiconsIcon icon={Route01Icon} size={20} strokeWidth={1.75} aria-hidden />
            </span>
            {m.scrape_router_title()}
          </h2>
          <p className="mt-3 max-w-xl text-balance text-16 text-text-2 s620:text-18">{m.scrape_router_sentence()}</p>
        </div>
        <ScrapeRouterSteps className="mx-auto mt-8 max-w-190" />
        <ScrapeRouterVideo className="mt-10" />
        <p className="mt-6 text-right text-12 text-text-3">{m.scrape_router_per1k()}</p>
        <ol className="mt-2 grid grid-cols-2 gap-2 s720:grid-cols-5">
          {BENCH_SERVICES.map((service) => (
            <BenchmarkCard key={service.name} service={service} />
          ))}
        </ol>
        <p className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-13 text-text-3">
          <span>{m.scrape_router_meta({ pages: SCRAPE_BENCHMARK.pages, date: fmtUtcDate(SCRAPE_BENCHMARK.measuredTo, 'short') })}</span>
          <a href={SCRAPE_BENCHMARK.gistUrl} target="_blank" rel="noreferrer" className="font-medium text-accent hover:underline">
            {m.scrape_router_link()} &rarr;
          </a>
        </p>
      </div>
    </div>
  </Band>
);
